var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "finishes-detail" }, [
    _c(
      "div",
      { staticClass: "background-pattern--one background-color--light" },
      [
        _c(
          "div",
          { staticClass: "grid-container padding-3" },
          [
            _c("image-slider", {
              attrs: { "current-slide": _vm.currentSlide },
              on: { select: _vm.onSliderSelect, change: _vm.onSlideChange }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid-container padding-3" },
      [
        _c("image-carousel", {
          attrs: { "current-slide": _vm.currentSlide },
          on: { select: _vm.onCarouselSelect }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }